import {
	BrowserModule,
	HAMMER_GESTURE_CONFIG,
	HammerGestureConfig,
	BrowserTransferStateModule
} from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { SharedModule } from './shared/shared.module';
import { AppStoreModule } from './store/app-store.module';
import { LayoutsModule } from './shared/layouts/layouts.module';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { AuthInterceptor } from './services/auth-interceptor.service';
import { Ng2BRPipesModule } from 'ng2-brpipes';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { registerLocaleData, APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { BrowserStateInterceptor } from './interceptors/browserstate.interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ClientRoutingModule } from './views/private/client/client-routing.module';
import { ClientModule } from './views/private/client/client.module';
import { translateServerLoaderFactory } from '@app-utils/translate-server-loader';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { environment } from '@env/environment';
import localePtBR from '@angular/common/locales/pt';
import localeEnUS from '@angular/common/locales/en';
import { GoogleMapsModule } from '@angular/google-maps';
import { LightboxModule } from '@ngx-gallery/lightbox';
import { GalleryModule } from '@ngx-gallery/core';
import { SkeletonElementsModule } from 'skeleton-elements/angular';

switch (environment.defaultLocale) {
	case 'pt-BR':
		registerLocaleData(localePtBR);
		break;
	default:
		registerLocaleData(localeEnUS);
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		AppRoutingModule,
		BrowserAnimationsModule,
		environment.production ? [] : AkitaNgDevtools.forRoot(),
		AkitaNgRouterStoreModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: translateServerLoaderFactory,
				deps: [HttpClient]
			},
			defaultLanguage: environment.defaultLocale
		}),
		SharedModule,
		AppStoreModule,
		LayoutsModule,
		HttpClientModule,
		BrowserTransferStateModule,
		ClientRoutingModule,
		ClientModule,
		MonacoEditorModule.forRoot(),
		GoogleMapsModule,
		LightboxModule,
		GalleryModule,
		SkeletonElementsModule
	],
	exports: [Ng2BRPipesModule],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: BrowserStateInterceptor, multi: true },
		{
			provide: LOCALE_ID,
			useValue: environment.defaultLocale
		},
		{ provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
		{ provide: 'LOCALSTORAGE', useFactory: getLocalStorage },
		{ provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig },
		{
			provide: APP_BASE_HREF,
			useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
			deps: [PlatformLocation]
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule {}

export function getLocalStorage() {
	return typeof window !== 'undefined' ? window.localStorage : null;
}
